export default "__VITE_ASSET__cc7c0739__"